/**
 * eventConfig.js — config-driven lookups for the event cascade (Phase 3).
 */
import { getCellCategories, buildCodeSet } from '@shared/incidentCategoryCascade.js';
import {
  getIncidentCategories as fallbackCategories,
  filterLhrReporterCategories,
} from './eventVocabularies.js';

/**
 * @param {object} config — the app config (must expose incidentCategoriesByTreatmentAndCode)
 * @param {string} treatment — e.g. 'LHR' | 'AWI'
 * @param {string} subtype — nested treatments only, e.g. 'Toxin' | 'Filler'
 * @param {string} code — severity value, e.g. 'Code 3'
 * @returns {string[]}
 */
export function getIncidentCategories(config, treatment, subtype, code) {
  const tree = config?.incidentCategoriesByTreatmentAndCode;
  if (!tree) return fallbackCategories(treatment, subtype, code);
  if (!treatment || !code) return [];
  const codeSet = buildCodeSet(config?.severityCodes);
  return getCellCategories(tree, treatment, subtype, code, codeSet);
}

/**
 * Incident categories for submission — applies LHR reporter limits unless the
 * user is Admin-tier (canManageRequirements).
 */
export function getIncidentCategoriesForUser(config, treatment, subtype, code, {
  canUseFullLhrCategories = false,
} = {}) {
  const categories = getIncidentCategories(config, treatment, subtype, code);
  return filterLhrReporterCategories(categories, treatment, code, {
    fullAccess: canUseFullLhrCategories,
  });
}
